import { SearchOutlined } from '@ant-design/icons'
import { Button, Input, Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import colors from 'helpers/colors'
import { useTranslation } from 'next-i18next'
import { VFC } from 'react'

type Props = {
  eventSearchText: string
  setEventSearchText: (value: string) => void
  eventSearchTextForPlacesCity: string
  setEventSearchTextForPlacesCity: (value: string) => void
  onClickOkButton: () => void
}

export const EventFilterForm: VFC<Props> = ({
  eventSearchText,
  setEventSearchText,
  eventSearchTextForPlacesCity,
  setEventSearchTextForPlacesCity,
  onClickOkButton,
}) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: 28,
        width: '100%',
      }}
    >
      <div style={{ padding: '16px 0px' }}>
        <Typography.Text
          style={{
            fontSize: 16,
            lineHeight: 1,
            color: colors.primary,
            fontWeight: 700,
          }}
        >
          {t('フィルター')}
        </Typography.Text>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <Typography.Text
          style={{ fontSize: 16, lineHeight: 1, color: colors.primary }}
        >
          {t('キーワード')}
        </Typography.Text>
        <Input
          placeholder={t('検索ワードを入力')}
          defaultValue={eventSearchText}
          value={eventSearchText}
          onChange={(e) => setEventSearchText(e.target.value)}
          onPressEnter={onClickOkButton}
          suffix={
            <SearchOutlined
              onClick={onClickOkButton}
              style={{ fontSize: '14px', color: colors.grey }}
            />
          }
          style={{ padding: 16, height: 48 }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <Typography.Text
          style={{ fontSize: 16, lineHeight: 1, color: colors.primary }}
        >
          {t('都市名')}
        </Typography.Text>
        <Input
          placeholder={t('都市名を入力')}
          defaultValue={eventSearchTextForPlacesCity}
          value={eventSearchTextForPlacesCity}
          onChange={(e) => setEventSearchTextForPlacesCity(e.target.value)}
          onPressEnter={onClickOkButton}
          suffix={
            <SearchOutlined
              onClick={onClickOkButton}
              style={{ fontSize: '14px', color: colors.grey }}
            />
          }
          style={{ padding: 16, height: 48 }}
        />
      </div>
      {xs && (
        <Button
          color="primary"
          style={{ marginTop: '12px' }}
          type="primary"
          onClick={onClickOkButton}
        >
          OK
        </Button>
      )}
    </div>
  )
}
